<div class="sidebar-tab-page-content copo-no-user-select sidenav-content" cdkScrollable>
	<div class="card-title-block">
		<span class="card-title-label" translate>home.order-tracking.my-schedule-business-order</span>
		<mat-form-field class="quick-search" appearance="outline" subscriptSizing="dynamic">
			<input
				[placeholder]="'search.placeholder' | translate"
				matInput
				type="text"
				spellcheck="false"
				autocomplete="off"
				[formControl]="searchTextControl"/>
			<button type="button" *ngIf="searchTextControl.value" mat-icon-button (click)="searchTextControl.reset('');" tabindex="-1" matSuffix>
				<mat-icon svgIcon="md:close"></mat-icon>
			</button>
			<mat-icon svgIcon="search" class="quick-search-icon" *ngIf="!searchTextControl.value" matSuffix></mat-icon>
		</mat-form-field>
		<button type="button" class="filter-button" (click)="goToFilter()">
			<span class="filter-button-name" translate>datacenter.filters</span>
			<mat-icon class="filter-button-icon" svgIcon="filters"></mat-icon>
		</button>
	</div>
	<ng-container *ngIf="!isLoading else loading">
		<div class="grid-6 copo-container" copoVirtualScroller [dataId]="dataId" #scroller="copoVirtualScroller" (moreDataNeeded)="onMoreDataNeeded($event.index, $event.limit, $event.provideData)">
			<div *ngFor="let scheduleBusinessOrder of scroller.list" class="grid-column-one-full card-block">
				<div class="card-portal">
					<div class="card-header">
						<div class="schedule-card-content">
							<div class="card-header-right">
								<mat-icon svgIcon="ordered" class="icon-alignement"></mat-icon>
								<span>
									{{ scheduleBusinessOrder.supplierOrderNumber ? scheduleBusinessOrder.supplierOrderNumber : UNDERSCORE }}
								</span>
							</div>
							<div class="list-container-column">
								<span class="list-header-label" translate>schedule-business-order.customer.order.number</span>
								<span class="list-header-text text-wrap">{{scheduleBusinessOrder.customerOrderNumber ? scheduleBusinessOrder.customerOrderNumber : UNDERSCORE}}</span>
							</div>
							<div class="list-container-column">
								<span class="list-header-label" translate>order-tracking.steelgrade</span>
								<span class="list-header-text text-wrap">{{scheduleBusinessOrder.steelgradeDescription ? scheduleBusinessOrder.steelgradeDescription : UNDERSCORE}}</span>
							</div>
						</div>
						<div class="card-header-right">
							<button type="button" *ngIf="scheduleBusinessOrder.isFavorite" [disabled]="scheduleBusinessOrder.isFavoriteDisabled" mat-icon-button
								(click)="deleteFavoriteSBOrder(scheduleBusinessOrder)">
								<mat-icon svgIcon="md:star"></mat-icon>
							</button>
	
							<button type="button" *ngIf="!scheduleBusinessOrder.isFavorite" [disabled]="scheduleBusinessOrder.isFavoriteDisabled" mat-icon-button
								(click)="saveFavoriteSBOrder(scheduleBusinessOrder)">
								<mat-icon svgIcon="md:star_border"></mat-icon>
							</button>
						</div>
					</div>
					<div class="card-content schedule-card-content">
						<div class="schedule-card-container-column">
							<div>
								<span class="tag-tonnage">{{ scheduleBusinessOrder.relaizedCumul | copoNumber:'weight':'t' }}</span>
							</div>
						</div>
						<div class="schedule-card-container-column">
							<div class="card-container-row ">							
								<mat-icon class="row-icon" svgIcon="at_consignment"></mat-icon>
								<span class="list-content-text">{{ scheduleBusinessOrder.millDescription ? scheduleBusinessOrder.millDescription : UNDERSCORE }}</span>
							</div>
						</div>
						<div class="list-container-column">
							<span class="list-content-label" translate>order-tracking.product.category</span>
							<span class="list-content-text">{{ scheduleBusinessOrder.productCategoryDescription ? scheduleBusinessOrder.productCategoryDescription : UNDERSCORE }}</span>
						</div>
						<div class="list-container-column">
							<span class="list-content-label" translate>order-tracking.dimension</span>
							<span class="list-content-text">{{ scheduleBusinessOrder | copoDimension }}</span>
						</div>
						<div class="list-container-column">
							<span class="list-content-label" translate>order-tracking.customerArticleReference</span>
							<span class="list-content-text">{{ scheduleBusinessOrder.customerArticleReference ? scheduleBusinessOrder.customerArticleReference : UNDERSCORE }}</span>
						</div>
						<div class="list-container-column card-column-around">
							<div class="card-container-link">
								<a mat-button color="primary" [routerLink]="['/order-tracking/schedule-business-order/card', scheduleBusinessOrder.supplierOrderNumber]">
									<span translate>delivery-tracking.view-details</span>
									<mat-icon iconPositionEnd color="accent" svgIcon="md:chevron_right"></mat-icon>
								</a>
							</div>
						</div>
					</div>
				</div>
				<div class="card-mobile">
					<div class="card-header">
						<div class="card-header-left">
							<mat-icon svgIcon="ordered" class="header-margin-right"></mat-icon>
						</div>
						<div class="list-container-column header-margin-right">
							<span>{{ scheduleBusinessOrder.supplierOrderNumber ? scheduleBusinessOrder.supplierOrderNumber: UNDERSCORE }}</span>
						</div>
						<div class="list-container-column header-margin-right">
							<span class="card-header-label" translate>order-tracking.steelgrade</span>
							<span>{{scheduleBusinessOrder.steelgradeDescription ? scheduleBusinessOrder.steelgradeDescription : UNDERSCORE}}</span>
						</div>
						<div class="card-header-right">
							<button type="button" *ngIf="scheduleBusinessOrder.isFavorite" [disabled]="scheduleBusinessOrder.isFavoriteDisabled" mat-icon-button
								(click)="deleteFavoriteSBOrder(scheduleBusinessOrder)">
								<mat-icon svgIcon="md:star"></mat-icon>
							</button>
	
							<button type="button" *ngIf="!scheduleBusinessOrder.isFavorite" [disabled]="scheduleBusinessOrder.isFavoriteDisabled" mat-icon-button
								(click)="saveFavoriteSBOrder(scheduleBusinessOrder)">
								<mat-icon svgIcon="md:star_border"></mat-icon>
							</button>
						</div>
					</div>
					<div class="card-content">
						<div class="content-grid-mobile">
							<div class="list-container-column">
								<span class="card-header-label" translate>batch.card.customer</span>
								<span>{{scheduleBusinessOrder.soldtoDescription ? scheduleBusinessOrder.soldtoDescription : UNDERSCORE}}</span>
							</div>
							<div class="card-container-row ">						
								<mat-icon class="row-icon" svgIcon="at_consignment"></mat-icon>
								<span>{{ scheduleBusinessOrder.millDescription ? scheduleBusinessOrder.millDescription : UNDERSCORE }}</span>
							</div>
							<div class="list-container-column">
								<span class="card-content-label" translate>order-tracking.product.category</span>
								<span>{{ scheduleBusinessOrder.productCategoryDescription ? scheduleBusinessOrder.productCategoryDescription : UNDERSCORE }}</span>
							</div>
							<div class="list-container-column">
								<span class="card-content-label" translate>order-tracking.dimension</span>
								<span>{{ scheduleBusinessOrder | copoDimension }}</span>
							</div>
							<div class="list-container-column">
								<span class="card-content-label" translate>order-tracking.customerArticleReference</span>
								<span>{{ scheduleBusinessOrder.customerArticleReference ? scheduleBusinessOrder.customerArticleReference : UNDERSCORE }}</span>
							</div>
						</div>
						<div class="list-container-column card-column-around">
							<div class="card-container-link">
								<a mat-button color="primary" [routerLink]="['/order-tracking/schedule-business-order/card', scheduleBusinessOrder.supplierOrderNumber]">
									<span translate>delivery-tracking.view-details</span>
									<mat-icon iconPositionEnd color="accent" svgIcon="md:chevron_right"></mat-icon>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<copo-loading-spinner class="grid-column-one-full" *ngIf="scroller.loading"></copo-loading-spinner>
			<div translate class="empty-page-text grid-column-one-full" *ngIf="!scroller.loading && scroller.list.length === 0">order-tracking.no.result</div>
		</div>
	</ng-container>
	<ng-template #loading>
		<copo-loading-spinner></copo-loading-spinner>
	</ng-template>
</div>